angular.module('app.api').factory('ApplicationStagesApi', [
  'api',
  function ApplicationStagesApi(api) {
    const applicationStagesApi = {
      getAllApplicationStages: payload => {
        return api.get(`applications/stages`, {params: payload})
      },
      createApplicationStage: payload => {
        return api.post(`applications/stages`, payload)
      },
      updateApplicationStage: (id, payload) => {
        return api.put(`applications/stage/${id}`, payload)
      },
      deleteApplicationStage: id => {
        return api.delete(`applications/stage/${id}`)
      },
      updateApplicationStageOrder: payload => {
        return api.put(`applications/stages/order`, payload)
      },
    }
    return applicationStagesApi
  },
])



// WEBPACK FOOTER //
// ./scripts/shared/directives/application/application-stages-setting/application-stages.api.js